import { defineMessages } from "@/i18n";
import en from "./en";

export const slackFrameMessages = defineMessages("frames-slack", en);
